import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { EventForm } from '../create/EventForm';
import { eventService, PostType } from '../../../services/eventService';
import { openMessageModal } from '../../../components/statusModal/messageModalActionCreators';
import { PanelRow } from '../../../components/panel/PanelRow';
import { Panel } from '../../../components/panel/Panel';
import { Spinner } from '../../../components/spinner/Spinner';

export const EventEdit = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { id } = useParams<{ id: string }>();
  const [eventData, setEventData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [postType, setPostType] = useState<PostType>('event');

  useEffect(() => {
    loadEvent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const loadEvent = async () => {
    try {
      setLoading(true);
      const data = await eventService.getEvent(id);
      setEventData(data);
      // Set the post type from loaded data
      setPostType(data.type || 'event');
    } catch (error) {
      console.error('Failed to load event:', error);
      dispatch(openMessageModal('Failed to load event', 'error'));
      history.push('/admin/content');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (data: any) => {
    const contentType = postType === 'event' ? 'Event' : 'Article';
    try {
      await eventService.updateEvent(id, data);
      dispatch(openMessageModal(`${contentType} updated successfully`, 'success'));
      history.push('/admin/content');
    } catch (error) {
      console.error(`Failed to update ${contentType.toLowerCase()}:`, error);
      dispatch(openMessageModal(`Failed to update ${contentType.toLowerCase()}`, 'error'));
      throw error;
    }
  };

  const handleCancel = () => {
    history.push('/admin/content');
  };

  if (loading) {
    return (
      <PanelRow>
        <Panel>
          <Spinner isLoading={true} />
        </Panel>
      </PanelRow>
    );
  }

  return (
    <PanelRow fluid>
      <Panel noPadding>
        <EventForm
          postType={postType}
          initialData={eventData}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          isEdit={true}
        />
      </Panel>
    </PanelRow>
  );
};
